import { render, staticRenderFns } from "./relic-detail.vue?vue&type=template&id=38e73ba2"
import script from "./relic-detail.vue?vue&type=script&lang=js"
export * from "./relic-detail.vue?vue&type=script&lang=js"
import style0 from "./relic-detail.vue?vue&type=style&index=0&id=38e73ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports